import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material/TextField';
import theme from '../theme';
import { CSSProperties } from 'react';
import { Colors } from 'library';

type InputProps = TextFieldProps & {
    noMargin?: boolean;
    paddingLeft?: CSSProperties['width'];
    backgroundColor?: CSSProperties['color'];
    underlineColor?: CSSProperties['color'];
};

const StyledInput = styled(TextField, {
    shouldForwardProp: (prop) => prop !== 'noMargin' && prop !== 'paddingLeft' && prop !== 'backgroundColor' && prop !== 'underlineColor',
})<InputProps>(({ noMargin, paddingLeft, backgroundColor = '#ffffff', underlineColor }) => ({
    marginBottom: noMargin ? 0 : 20,
    borderColor: underlineColor ?? theme.palette.primary.main,
    '& label.Mui-focused': {
        color: theme.palette.primary.main,
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: underlineColor ?? theme.palette.primary.main,
    },
    '& .MuiInput-underline::before': {
        borderColor: underlineColor ?? theme.palette.primary.main,
    },
    '& .MuiOutlinedInput-root': {
        borderRadius: 18,
        '& fieldset': {
            borderColor: underlineColor ?? theme.palette.primary.main,
            borderRadius: 18,
        },
        '&:hover fieldset': {
            borderColor: underlineColor ?? theme.palette.primary.main,
        },
        '&.Mui-focused fieldset': {
            borderColor: underlineColor ?? theme.palette.primary.main,
            color: theme.palette.primary.main,
        },
    },
    '& .MuiInputBase-input': {
        backgroundColor,
        paddingLeft,
        color: Colors.darkNavy,
        borderRadius: 18,
    },
    '& .MuiOutlinedInput-input': {
        backgroundColor,
        borderRadius: 18,
    },
    '& .MuiTextField-root': {
        '& fieldset': {
            backgroundColor,
        },
        '&:hover fieldset': {
            borderColor: underlineColor ?? theme.palette.primary.main,
        },
        '&.Mui-focused fieldset': {
            borderColor: underlineColor ?? theme.palette.primary.main,
        },
    },
    '&:hover:not($disabled):after': {
        borderColor: underlineColor ?? theme.palette.primary.main,
    },
    '&:hover:not($disabled):before': {
        borderColor: underlineColor ?? theme.palette.primary.main,
    },
}));

StyledInput.defaultProps = {
    variant: 'standard',
};

export default StyledInput;
